/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/newInput';
import Select from '~/components/select';
import { GeneralParametersData } from '~/services/banknow/types';

const CAPTURE_FORMS = [
  { id: 'POS TEUPAG', value: 'POS TEUPAG' },
  { id: 'SITEF', value: 'SITEF' },
  { id: 'POSTEUPAGSITEF', value: 'AMBOS' },
];
const CONDITIONS = [
  { id: 'ANTECIPADO', value: 'ANTECIPADO' },
  { id: 'FLUXO', value: 'NO FLUXO' },
];
const GeneralData = forwardRef(({
  defaultValues,
  onChange,
}: {
  defaultValues: GeneralParametersData;
  onChange: (values: GeneralParametersData) => void;
}, ref) => {
  const [values, setValues] = useState(defaultValues);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    onChange(values);
  }, [values]);

  const getNestedValue = (obj, path) => {
    return path.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      obj,
    );
  };

  const handleErrors = () => {
    const fieldsToCheck = [
      'mcc',
      'captureMethod',
      'posQuantity',
      'monthlyCardTotalRevenue',
      'repassCondition',
    ]

    const errors = {}

    fieldsToCheck.forEach((field) => {
      const value = getNestedValue(values, field.split('.'));
      console.log('VALUE AGREEMENT', value);
      if (value === undefined || value === null || value === '' || value === '' || value.length === 0) {
        errors[field] = 'Campo obrigatório';
      }
    });

    setErrors(errors);

    return Object.keys(errors).length > 0;
  }

  useImperativeHandle(ref, () => ({
    handleErrors,
  }));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <ContainerFlex gap={12} row space marginTop={20}>
      <ContainerFlex>
        <Input
          mask={MaskTypes.NUMERIC}
          value={values?.mcc}
          name="mcc"
          label="MCC"
          onChange={handleChange}
          errorMessage={errors['mcc']}
        />
        <ContainerFlex row spacing gap="8">
          <ContainerFlex>
            <Select
              options={CAPTURE_FORMS}
              name="captureMethod"
              label="Forma de Captura"
              value={values?.captureMethod}
              onChange={(e) =>
                handleChange({ target: { name: 'captureMethod', value: e } })
              }
              errorMessage={errors['captureMethod']}
            />
          </ContainerFlex>
          <ContainerFlex>
            <Input
              mask={MaskTypes.NUMERIC}
              name="posQuantity"
              label="Quantidade POS"
              value={values?.posQuantity}
              onChange={handleChange}
              errorMessage={errors['posQuantity']}
            />
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex>
        <Input
          mask={MaskTypes.NUMERIC}
          name="monthlyCardTotalRevenue"
          label="Faturamento total mensal bandeirado"
          value={values?.monthlyCardTotalRevenue}
          onChange={handleChange}
          errorMessage={errors['monthlyCardTotalRevenue']}
        />
        <Select
          options={CONDITIONS}
          name="repassCondition"
          label="Condição de repasse"
          value={values?.repassCondition}
          onChange={(e) =>
            handleChange({ target: { name: 'repassCondition', value: e } })
          }
          errorMessage={errors['repassCondition']}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
});
export default GeneralData;
